import React from 'react';

import { CheckoutTabHeaderProps } from './checkout-tab-header.props';
import Link from 'next/link';
import { Route } from '../../../enums';

export const CheckoutTabHeaderMolecule = (props: CheckoutTabHeaderProps) => {
  const addClass = props.displayBorder && 'border-b border-waldo-blue';
  return (
    <div className={`tab ${addClass}`}>
      <div className="w-11/12 lg:w-full mx-auto relative">
        <h2 className="text-tabTitle font-waldo-regular py-6">{props.title}</h2>

        {props.editable && (
          <div className="absolute right-0 top-7">
            <Link href={props.editLink}>
              <a className="uppercase underline_blue">Edit</a>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

CheckoutTabHeaderMolecule.defaultProps = {
  displayBorder: true,
  editable: false,
  editLink: Route.PATIENT_REGISTER,
};
